/* eslint no-undef: 0 */
export default preval`const resolveConfig = require('tailwindcss/resolveConfig')
const tailwindConfig = require('../../tailwind.config')
module.exports = resolveConfig(tailwindConfig)
`
